<script setup>
import {reactive, inject, ref, onMounted} from "vue";
//import functions
//import components
import {Icon} from "@iconify/vue";
import {
  Dialog,
  InputText,
  FloatLabel
} from "primevue";
//import stores
import {useWatchdogStore} from "@/stores/watchdog.js";
//import composables
import {useBreakpoint} from "@/composables/useBreakpoint.js";
import {useLoadingFlags} from "@/composables/useLoadingFlags.js";
import {useToast} from "primevue/usetoast";
import {useRouter} from "vue-router";
import {showMessage} from "@/utils/showMessage.js";
import showAlert from "@/utils/showAlert.js";

//stores
const watchdogStore = useWatchdogStore();

//loading flags
const {
  saving,
  fetching,
  loading,
  setSaving,
  setFetching,
  setLoading,
} = useLoadingFlags()
const isUploadingAttachment = ref(false)


//other composables
const {isXL} = useBreakpoint();
const toast = useToast();
const router = useRouter()

//emits
const emit = defineEmits(['refresh']);

//props
const props = defineProps({
  offer: {
    type: Object,
    required: true
  }
})

//injects
const visible = inject('isShowAddTrackerModal')

//component variables
const stores = [
  {
    value: 'DealHub USD',
    label: 'DealHub USD',
  },
  {
    value: 'Incepto USD',
    label: 'Incepto USD',
  }
]
const types = [
  {
    value: 'Boost',
    label: 'Boost',
  }
]
const tracker = reactive({
  "trackerID": ""
})

//component functions
const onSave = async () => {
  //emit('save', offer)
  try {
    setLoading(true)
    const res = await watchdogStore.action_addTracker({
      "offerID": props.offer.offerID,
      "trackerID": tracker.trackerID
    })
    if (res.result === true) {
      showMessage('New Tracker Added.', 'success');
      emit('refresh')
      visible.value = false
    } else {
      showMessage(res, 'error')
    }
  } catch (e) {
    showMessage(e, 'error')
  } finally {
    setLoading(false)
  }
}

//hooks
onMounted(() => {

})

//provides

</script>

<template>
  <Dialog v-model:visible="visible"
          :class="['max-w-3xl !border-0 !rounded-md !bg-[#0e1726]', isXL ? '' : 'w-full']"
          :position="isXL ? 'center' : 'bottom'"
          closable dismissable-mask draggable modal
          content-class="min-w-full min-h-full flex flex-col gap-4 overflow-hidden h-full w-full max-w-[calc(100vw-20px)] max-h-[calc(100vh-100px)] !px-3">
    <template #header>
      <div class="text-base py-3">
        Add New Tracker
      </div>
    </template>
    <template #closebutton="{closeCallback}">
      <div class="h-full w-[1px] bg-slate-700"></div>
      <button
          type="button"
          class="text-white-dark outline-none hover:text-red-500"
          @click="closeCallback"
      >
        <Icon icon="pajamas:close-xs"/>
      </button>
    </template>
    <div class="flex-1 flex flex-col gap-4 overflow-y-auto pt-4 px-2 pb-1 text-xs 2xl:text-sm min-w-80 max-w-full">
      <div>
        <FloatLabel variant="on">
          <InputText id="offerID" :value="offer.offerID" autocomplete="off" readonly disabled
                     class="!bg-transparent w-full rounded-md h-[32px] 2xl:h-[40px] !text-xs 2xl:!text-sm !border-slate-700"
                     :class="{'p-filled': !!offer.offerID }"/>
          <label for="offerID" class="!bg-slate-900">Offer ID</label>
        </FloatLabel>
      </div>
      <div>
        <FloatLabel variant="on">
          <InputText id="store" :value="offer.store" autocomplete="off" readonly disabled
                     class="!bg-transparent w-full rounded-md h-[32px] 2xl:h-[40px] !text-xs 2xl:!text-sm !border-slate-700"
                     :class="{'p-filled': !!offer.store }"/>
          <label for="store" class="!bg-slate-900">Store</label>
        </FloatLabel>
      </div>
      <div>
        <FloatLabel variant="on">
          <InputText id="offerType" :value="offer.type" autocomplete="off" readonly disabled
                     class="!bg-transparent w-full rounded-md h-[32px] 2xl:h-[40px] !text-xs 2xl:!text-sm !border-slate-700"
                     :class="{'p-filled': !!offer.type }"/>
          <label for="offerType" class="!bg-slate-900">Type</label>
        </FloatLabel>
      </div>
      <div>
        <FloatLabel variant="on">
          <InputText id="offerLink" :value="offer.offerLink" autocomplete="off" readonly disabled
                     class="!bg-transparent w-full rounded-md h-[32px] 2xl:h-[40px] !text-xs 2xl:!text-sm !border-slate-700"
                     :class="{'p-filled': !!offer.offerLink }"/>
          <label for="offerLink" class="!bg-slate-900">Offer Link</label>
        </FloatLabel>
      </div>
      <div>
        <FloatLabel variant="on">
          <InputText id="trackerID" v-allow-digits v-model="tracker.trackerID" autocomplete="off"
                     class="!bg-transparent w-full rounded-md h-[32px] 2xl:h-[40px] !text-xs 2xl:!text-sm !border-slate-700"/>
          <label for="trackerID" class="!bg-slate-900">Tracker ID</label>
        </FloatLabel>
      </div>
    </div>
    <div class="flex justify-end gap-3">
      <button @click="onSave"
              class="btn btn-outline-dark flex items-center justify-center gap-3 disabled:opacity-50 py-1"
              :disabled="saving || loading">
        Save
        <Icon v-if="saving" icon="eos-icons:bubble-loading" height="24"/>
      </button>
    </div>
  </Dialog>
</template>
<style>
.swal2-container.swal2-center.swal2-backdrop-show {
  z-index: 100000;
}
</style>